import React from 'react'

const ViewAll = () => {
  return (
    <div>ViewAll</div>
  )
}

export default ViewAll